export const NewsfeedNotificationObservables = {
    IssueCreation: 0,
    IssueChange: 1,
    IssueDeletion: 2,
    IncomingEMail: 3,
    OutgoingEMail: 4,
    IssueItemCreation: 5,
    IssueItemChange: 6,
    IssueItemDeletion: 7
}